package com.schoolconnect.app.feature.academicyears

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import com.schoolconnect.app.designsystem.AppDropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.foundation.text.BasicTextField
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.appDateInputComparable
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppLine
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import com.schoolconnect.app.designsystem.AppSurface
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppSecondaryBackground
import com.schoolconnect.app.designsystem.AppSurface
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.calendar
import ischoolconnect.sharedui.generated.resources.clock
import ischoolconnect.sharedui.generated.resources.filter
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.chevron_left
import ischoolconnect.sharedui.generated.resources.chevron_right
import ischoolconnect.sharedui.generated.resources.more_vertical
import ischoolconnect.sharedui.generated.resources.plus
import ischoolconnect.sharedui.generated.resources.search
import org.jetbrains.compose.resources.painterResource
import com.schoolconnect.app.designsystem.list.AdminStandardRowActionMenu
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminListPagination
import com.schoolconnect.app.feature.common.PaginationPolicy
import com.schoolconnect.app.designsystem.list.AdminListRowsPerPageButton
import com.schoolconnect.app.designsystem.list.AdminListSearchField
import com.schoolconnect.app.designsystem.list.AdminListToolbarButton
import com.schoolconnect.app.feature.common.compareBySmartText
import com.schoolconnect.app.feature.common.pageCountForTotal
import com.schoolconnect.app.feature.common.pageFooterText
import com.schoolconnect.app.feature.common.pageWindow

internal val AcademicYearsBackground = AppSecondaryBackground
internal val AcademicYearsCard = AppSurface
internal val AcademicYearsPrimary = AppPrimary
internal val AcademicYearsNavy = AppNavy
internal val AcademicYearsMuted = AppMuted
internal val AcademicYearsBorder = AppBorder
internal val AcademicYearsLine = AppLine
internal val AcademicYearsPageBlue = AppPrimary
internal val AcademicYearsPageBlueSoft = AppPrimarySoft
internal val AcademicYearsShadow = Color(0x0D233A7E)
internal val AcademicYearsInputBg = Color(0xFFFFFFFF)

private val AcademicYearsCardShape = RoundedCornerShape(12.dp)
private val AcademicYearsMenuShape = RoundedCornerShape(18.dp)

internal val AcademicYearDefaultSchoolOptions = listOf(
    "Oxford Public School",
    "Greenfield High School",
    "Sunshine Public School",
    "Viterine School",
    "Bright Future School",
    "Nexus International School",
    "Sunrise International School"
)

internal fun academicYearFixture(): List<AcademicYearListItem> = listOf(
    AcademicYearListItem("ay-1", school = "Greenfield High School", academicYear = "2026-27", startDate = "01 Jun 2026", endDate = "31 Mar 2027", status = AcademicYearStatus.ACTIVE),
    AcademicYearListItem("ay-2", school = "Vidyadayinee School", academicYear = "2026-27", startDate = "01 Jun 2026", endDate = "31 Mar 2027", status = AcademicYearStatus.ACTIVE),
    AcademicYearListItem("ay-3", school = "Canara High School", academicYear = "2026-27", startDate = "01 Apr 2026", endDate = "31 Mar 2027", status = AcademicYearStatus.ACTIVE),
    AcademicYearListItem("ay-4", school = "Orchid International School", academicYear = "2026-27", startDate = "01 Apr 2026", endDate = "31 Mar 2027", status = AcademicYearStatus.ACTIVE),
    AcademicYearListItem("ay-5", school = "Bright Future Academy", academicYear = "2026-27", startDate = "01 Jun 2026", endDate = "31 Mar 2027", status = AcademicYearStatus.ACTIVE),
    AcademicYearListItem("ay-6", school = "Horizon Public School", academicYear = "2026-27", startDate = "01 Jun 2026", endDate = "31 Mar 2027", status = AcademicYearStatus.ACTIVE),
    AcademicYearListItem("ay-7", school = "St. Xavier's International", academicYear = "2026-27", startDate = "01 Apr 2026", endDate = "31 Mar 2027", status = AcademicYearStatus.ACTIVE),
    AcademicYearListItem("ay-8", school = "Maple Leaf School", academicYear = "2026-27", startDate = "01 Jun 2026", endDate = "31 Mar 2027", status = AcademicYearStatus.ACTIVE),
    AcademicYearListItem("ay-9", school = "Sunrise Convent", academicYear = "2026-27", startDate = "01 Apr 2026", endDate = "31 Mar 2027", status = AcademicYearStatus.ACTIVE),
    AcademicYearListItem("ay-10", school = "NextGen Public School", academicYear = "2027-28", startDate = "01 Jun 2027", endDate = "31 Mar 2028", status = AcademicYearStatus.UPCOMING),
    AcademicYearListItem("ay-11", school = "Riverdale International School", academicYear = "2028-29", startDate = "01 Jun 2028", endDate = "31 Mar 2029", status = AcademicYearStatus.UPCOMING),
    AcademicYearListItem("ay-12", school = "Summit Ridge School", academicYear = "2027-28", startDate = "01 Apr 2027", endDate = "31 Mar 2028", status = AcademicYearStatus.UPCOMING),
    AcademicYearListItem("ay-13", school = "Crestview Academy", academicYear = "2028-29", startDate = "01 Apr 2028", endDate = "31 Mar 2029", status = AcademicYearStatus.UPCOMING),
    AcademicYearListItem("ay-14", school = "Sunshine Public School", academicYear = "2025-26", startDate = "01 Jun 2025", endDate = "31 Mar 2026", status = AcademicYearStatus.CLOSED),
    AcademicYearListItem("ay-15", school = "Vitrght School", academicYear = "2025-26", startDate = "01 Apr 2025", endDate = "31 Mar 2026", status = AcademicYearStatus.CLOSED),
    AcademicYearListItem("ay-16", school = "Old Town School", academicYear = "2024-25", startDate = "01 Jun 2024", endDate = "31 Mar 2025", status = AcademicYearStatus.CLOSED),
    AcademicYearListItem("ay-17", school = "Bluebell Academy", academicYear = "2024-25", startDate = "01 Apr 2024", endDate = "31 Mar 2025", status = AcademicYearStatus.CLOSED),
    AcademicYearListItem("ay-18", school = "Central Municipal School", academicYear = "2023-24", startDate = "01 Jun 2023", endDate = "31 Mar 2024", status = AcademicYearStatus.CLOSED)
)

internal fun AcademicYearListItem.toDraft(): AcademicYearEditorDraft = AcademicYearEditorDraft(
    id = id,
    schoolId = schoolId,
    academicYear = academicYear,
    school = school,
    startDate = startDate,
    endDate = endDate,
    status = status,
    isActive = isActive,
    createdOn = createdOn,
    updatedOn = updatedOn
)

internal fun AcademicYearEditorDraft.toItem(id: String): AcademicYearListItem = AcademicYearListItem(
    id = id,
    schoolId = schoolId,
    academicYear = academicYear.ifBlank { "2026-27" },
    school = school.ifBlank { "New School" },
    startDate = startDate.ifBlank { "01 Jun 2026" },
    endDate = endDate.ifBlank { "31 Mar 2027" },
    status = status,
    isActive = isActive,
    createdOn = createdOn.ifBlank { "10 May 2026" },
    updatedOn = updatedOn.ifBlank { "14 Jun 2026" }
)

internal fun filteredAcademicYears(
    items: List<AcademicYearListItem>,
    filters: AcademicYearFilterCriteria
): List<AcademicYearListItem> {
    val query = filters.searchQuery.trim()
    return items.filter { item ->
        val matchesSearch =
            query.isBlank() ||
                buildList {
                    add(item.academicYear)
                    add(item.school)
                    add(item.startDate)
                    add(item.endDate)
                    add(item.createdOn)
                    add(item.updatedOn)
                }.joinToString(" ").contains(query, ignoreCase = true)

        val matchesSchool = filters.school.isBlank() || item.school.contains(filters.school.trim(), ignoreCase = true)
        val matchesActiveStatus = when (filters.activeStatus) {
            AcademicYearActiveStatusFilter.ALL -> true
            AcademicYearActiveStatusFilter.ACTIVE -> item.isActive
            AcademicYearActiveStatusFilter.INACTIVE -> !item.isActive
        }
        val matchesFilter = when (filters.status) {
            AcademicYearsFilter.ALL -> true
            AcademicYearsFilter.ACTIVE -> item.status == AcademicYearStatus.ACTIVE
            AcademicYearsFilter.UPCOMING -> item.status == AcademicYearStatus.UPCOMING
            AcademicYearsFilter.CLOSED -> item.status == AcademicYearStatus.CLOSED
        }
        val matchesStartYear = filters.startYear.isBlank() || academicYearYearComparable(item.startDate)?.toString() == filters.startYear.trim()
        val matchesEndYear = filters.endYear.isBlank() || academicYearYearComparable(item.endDate)?.toString() == filters.endYear.trim()
        val matchesCreatedFrom = academicYearDateComparableFilter(item.createdOn, filters.createdFrom, lowerBound = true)
        val matchesCreatedTo = academicYearDateComparableFilter(item.createdOn, filters.createdTo, lowerBound = false)
        matchesSearch && matchesSchool && matchesActiveStatus && matchesFilter && matchesStartYear && matchesEndYear && matchesCreatedFrom && matchesCreatedTo
    }
}

internal fun sortedAcademicYears(
    items: List<AcademicYearListItem>,
    sortField: AcademicYearsSortField,
    ascending: Boolean
): List<AcademicYearListItem> =
    items.sortedWith(academicYearsComparator(sortField, ascending))

private fun academicYearsComparator(
    sortField: AcademicYearsSortField,
    ascending: Boolean
): Comparator<AcademicYearListItem> {
    val comparator = when (sortField) {
        AcademicYearsSortField.ACADEMIC_YEAR -> compareBySmartText<AcademicYearListItem> { it.academicYear }
        AcademicYearsSortField.SCHOOL -> compareBySmartText<AcademicYearListItem> { it.school }
        AcademicYearsSortField.START_DATE -> compareBy<AcademicYearListItem> { academicYearDateComparable(it.startDate) ?: 0 }
        AcademicYearsSortField.END_DATE -> compareBy<AcademicYearListItem> { academicYearDateComparable(it.endDate) ?: 0 }
        AcademicYearsSortField.LIFECYCLE -> compareBy<AcademicYearListItem> {
            when (it.status) {
                AcademicYearStatus.ACTIVE -> 0
                AcademicYearStatus.UPCOMING -> 1
                AcademicYearStatus.CLOSED -> 2
            }
        }.then(compareBySmartText { it.school })
        AcademicYearsSortField.STATUS -> compareBy<AcademicYearListItem> { if (it.isActive) 0 else 1 }
    }
    return if (ascending) comparator else comparator.reversed()
}

internal fun pagedAcademicYears(
    items: List<AcademicYearListItem>,
    pageIndex: Int,
    rowsPerPage: Int
): List<AcademicYearListItem> {
    val safeRows = rowsPerPage.coerceAtLeast(1)
    val start = (pageIndex.coerceAtLeast(0) * safeRows).coerceAtMost(items.size)
    val end = (start + safeRows).coerceAtMost(items.size)
    return items.subList(start, end)
}

internal fun pageCount(total: Int, rowsPerPage: Int): Int =
    pageCountForTotal(total, rowsPerPage)

internal fun visibleRangeLabel(
    pageIndex: Int,
    rowsPerPage: Int,
    total: Int
): String {
    return pageFooterText(pageWindow(pageIndex, rowsPerPage, total), "academic years")
}

internal fun academicYearFilterSchoolOptions(items: List<AcademicYearListItem>): List<String> =
    items.asSequence()
        .map { it.school.trim() }
        .filter { it.isNotBlank() }
        .distinct()
        .sortedWith(compareBySmartText<String> { it })
        .toList()

internal fun academicYearFilterYearOptions(items: List<AcademicYearListItem>, selector: (AcademicYearListItem) -> String): List<String> =
    items.asSequence()
        .mapNotNull { item -> academicYearYearComparable(selector(item))?.toString() }
        .distinct()
        .sortedWith(compareBySmartText<String> { it }.reversed())
        .toList()

internal fun academicYearYearComparable(value: String): Int? {
    val trimmed = value.trim()
    if (trimmed.isBlank()) return null

    Regex("""(\d{4})""").find(trimmed)?.let { match ->
        return match.groupValues[1].toIntOrNull()
    }

    return null
}

internal fun academicYearDateComparableFilter(rowDate: String, filterDate: String, lowerBound: Boolean): Boolean {
    val comparableFilter = academicYearDateComparable(filterDate) ?: return true
    val comparableRow = academicYearDateComparable(rowDate) ?: return false
    return if (lowerBound) comparableRow >= comparableFilter else comparableRow <= comparableFilter
}

internal fun academicYearDateComparable(value: String): Int? {
    appDateInputComparable(value)?.let { return it }
    val trimmed = value.trim()
    if (trimmed.isBlank()) return null

    val iso = Regex("""^(\d{4})-(\d{2})-(\d{2})$""").matchEntire(trimmed)
    if (iso != null) {
        val year = iso.groupValues[1].toIntOrNull() ?: return null
        val month = iso.groupValues[2].toIntOrNull() ?: return null
        val day = iso.groupValues[3].toIntOrNull() ?: return null
        if (month !in 1..12 || day !in 1..31) return null
        return year * 10_000 + month * 100 + day
    }

    val dmy = Regex("""^(\d{2})[/-](\d{2})[/-](\d{4})$""").matchEntire(trimmed)
    if (dmy != null) {
        val day = dmy.groupValues[1].toIntOrNull() ?: return null
        val month = dmy.groupValues[2].toIntOrNull() ?: return null
        val year = dmy.groupValues[3].toIntOrNull() ?: return null
        if (month !in 1..12 || day !in 1..31) return null
        return year * 10_000 + month * 100 + day
    }

    val monthNames = mapOf(
        "jan" to 1, "january" to 1,
        "feb" to 2, "february" to 2,
        "mar" to 3, "march" to 3,
        "apr" to 4, "april" to 4,
        "may" to 5,
        "jun" to 6, "june" to 6,
        "jul" to 7, "july" to 7,
        "aug" to 8, "august" to 8,
        "sep" to 9, "september" to 9,
        "oct" to 10, "october" to 10,
        "nov" to 11, "november" to 11,
        "dec" to 12, "december" to 12
    )
    val parts = trimmed.split(Regex("""\s+"""))
    if (parts.size == 3) {
        val day = parts[0].toIntOrNull() ?: return null
        val month = monthNames[parts[1].lowercase()] ?: return null
        val year = parts[2].toIntOrNull() ?: return null
        if (month !in 1..12 || day !in 1..31) return null
        return year * 10_000 + month * 100 + day
    }

    return null
}

@Composable
internal fun AcademicYearKpiCard(
    title: String,
    value: String,
    subtitle: String,
    iconPainter: Painter,
    iconTint: Color,
    iconBg: Color,
    modifier: Modifier = Modifier
) {
    Card(
        modifier = modifier,
        shape = AcademicYearsCardShape,
        colors = CardDefaults.cardColors(containerColor = AcademicYearsCard),
        border = androidx.compose.foundation.BorderStroke(1.dp, AcademicYearsBorder),
        elevation = CardDefaults.cardElevation(defaultElevation = 2.dp)
    ) {
        Row(
            modifier = Modifier.padding(horizontal = 18.dp, vertical = 24.dp),
            horizontalArrangement = Arrangement.spacedBy(16.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Box(
                modifier = Modifier
                    .size(68.dp)
                    .background(iconBg, RoundedCornerShape(12.dp)),
                contentAlignment = Alignment.Center
            ) {
                Icon(
                    painter = iconPainter,
                    contentDescription = title,
                    tint = iconTint,
                    modifier = Modifier.size(30.dp)
                )
            }
            Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
                Text(
                    text = title,
                    color = AcademicYearsNavy,
                    fontSize = 13.sp,
                    fontWeight = FontWeight.SemiBold
                )
                Text(
                    text = value,
                    color = AcademicYearsNavy,
                    fontSize = 30.sp,
                    lineHeight = 32.sp,
                    fontWeight = FontWeight.Bold
                )
                Text(
                    text = subtitle,
                    color = AcademicYearsMuted,
                    fontSize = 13.sp,
                    fontWeight = FontWeight.Medium
                )
            }
        }
    }
}

@Composable
internal fun AcademicYearsSearchField(
    value: String,
    onValueChange: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    AdminListSearchField(
        value = value,
        onValueChange = onValueChange,
        placeholder = "Search by school or year...",
        modifier = modifier,
        width = 370.dp,
        surfaceColor = AcademicYearsCard,
        borderColor = AcademicYearsBorder,
        iconTint = AcademicYearsMuted,
        textColor = AcademicYearsNavy,
        cursorColor = AcademicYearsPrimary
    )
}

@Composable
internal fun AcademicYearsToolbarButton(
    label: String,
    icon: Painter,
    onClick: () -> Unit,
    width: Dp
) {
    AdminListToolbarButton(
        label = label,
        icon = icon,
        onClick = onClick,
        width = width,
        borderColor = AcademicYearsBorder,
        contentColor = AcademicYearsPrimary,
        iconSize = 19.dp
    )
}

@Composable
internal fun AcademicYearsRowsPerPageButton(
    pageSize: Int,
    expanded: Boolean,
    onClick: () -> Unit
) {
    AdminListRowsPerPageButton(
        pageSize = pageSize,
        expanded = expanded,
        onClick = onClick,
        width = 82.dp,
        height = 44.dp,
        borderColor = AcademicYearsBorder,
        surfaceColor = AcademicYearsCard,
        contentColor = AcademicYearsNavy,
        iconTint = AcademicYearsMuted
    )
}

@Composable
internal fun AcademicYearsFilterButton(
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    AdminListToolbarButton(
        label = "Filter",
        icon = painterResource(Res.drawable.filter),
        onClick = onClick,
        modifier = modifier,
        width = 116.dp,
        borderColor = AcademicYearsBorder,
        contentColor = AcademicYearsPrimary,
        iconSize = 19.dp
    )
}

@Composable
internal fun AcademicYearStatusChip(status: AcademicYearStatus) {
    AdminListTableBodyText(
        text = status.label,
        color = status.accent
    )
}

@Composable
internal fun AcademicYearActiveStatusChip(isActive: Boolean) {
    val label = if (isActive) "Active" else "Inactive"
    val accent = if (isActive) Color(0xFF16A34A) else Color(0xFFDC2626)
    AdminListTableBodyText(text = label, color = accent)
}

@Composable
internal fun AcademicYearsToolbarContainer(
    modifier: Modifier = Modifier,
    content: @Composable RowScope.() -> Unit
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .height(80.dp)
            .background(AcademicYearsCard, RoundedCornerShape(10.dp))
            .border(1.dp, AcademicYearsBorder, RoundedCornerShape(10.dp))
            .padding(horizontal = 16.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
        content = content
    )
}

@Composable
internal fun AcademicYearsRowMenu(
    expanded: Boolean,
    onDismissRequest: () -> Unit,
    isActive: Boolean,
    onViewDetails: () -> Unit,
    onEdit: () -> Unit,
    onToggleStatus: () -> Unit,
    onDelete: () -> Unit
) {
    AdminStandardRowActionMenu(
        isActive = isActive,
        expanded = expanded,
        onDismissRequest = onDismissRequest,
        onView = onViewDetails,
        onEdit = onEdit,
        onToggleStatus = onToggleStatus,
        onDelete = onDelete,
        toggleStatusLabel = if (isActive) "Inactivate" else "Activate",
        width = 190.dp,
        surfaceColor = AcademicYearsCard,
        borderColor = AcademicYearsBorder
    )
}

@Composable
internal fun AcademicYearsPagination(
    pageIndex: Int,
    pageCount: Int,
    onPageChanged: (Int) -> Unit,
    modifier: Modifier = Modifier
) {
    AdminListPagination(
        pageIndex = pageIndex,
        pageCount = pageCount,
        onPageChanged = onPageChanged,
        modifier = modifier,
        borderColor = AcademicYearsBorder,
        surfaceColor = AcademicYearsCard,
        primaryColor = AcademicYearsPrimary,
        navyColor = AcademicYearsNavy,
        mutedColor = AcademicYearsMuted
    )
}

private sealed interface AcademicYearsPageButton {
    data class Number(val number: Int) : AcademicYearsPageButton
    data object Ellipsis : AcademicYearsPageButton
}

private fun buildAcademicYearsPagination(pageIndex: Int, pageCount: Int): List<AcademicYearsPageButton> {
    if (pageCount <= 7) {
        return (1..pageCount).map { AcademicYearsPageButton.Number(it) }
    }

    val currentPage = pageIndex + 1
    return when {
        currentPage <= 4 -> listOf(
            1, 2, 3, 4, 5
        ).map { AcademicYearsPageButton.Number(it) } + listOf(
            AcademicYearsPageButton.Ellipsis,
            AcademicYearsPageButton.Number(pageCount)
        )

        currentPage >= pageCount - 3 -> listOf(
            AcademicYearsPageButton.Number(1),
            AcademicYearsPageButton.Ellipsis
        ) + ((pageCount - 4)..pageCount).map { AcademicYearsPageButton.Number(it) }

        else -> listOf(
            AcademicYearsPageButton.Number(1),
            AcademicYearsPageButton.Ellipsis,
            AcademicYearsPageButton.Number(currentPage - 1),
            AcademicYearsPageButton.Number(currentPage),
            AcademicYearsPageButton.Number(currentPage + 1),
            AcademicYearsPageButton.Ellipsis,
            AcademicYearsPageButton.Number(pageCount)
        )
    }
}

@Composable
private fun PageNavButton(
    iconPainter: Painter,
    enabled: Boolean,
    onClick: () -> Unit
) {
    Box(
        modifier = Modifier
            .size(28.dp)
            .background(Color.White, RoundedCornerShape(99.dp))
            .border(1.dp, AcademicYearsBorder, RoundedCornerShape(99.dp)),
        contentAlignment = Alignment.Center
    ) {
        IconButton(
            onClick = onClick,
            enabled = enabled,
            modifier = Modifier.size(28.dp)
        ) {
            Icon(
                painter = iconPainter,
                contentDescription = null,
                tint = AcademicYearsNavy,
                modifier = Modifier.size(16.dp)
            )
        }
    }
}

@Composable
internal fun AcademicYearsRowsPerPageSelect(
    value: Int,
    onValueClick: () -> Unit,
    expanded: Boolean,
    onDismiss: () -> Unit,
    onSelect: (Int) -> Unit,
    modifier: Modifier = Modifier
) {
    Box(modifier = modifier) {
        AcademicYearsRowsPerPageButton(
            pageSize = value,
            expanded = expanded,
            onClick = onValueClick
        )
        AppDropdownMenu(expanded = expanded, onDismissRequest = onDismiss, containerColor = AppSurface) {
            PaginationPolicy.PAGE_SIZE_OPTIONS.forEach { option ->
                DropdownMenuItem(
                    text = { Text(option.toString()) },
                    onClick = {
                        onSelect(option)
                        onDismiss()
                    }
                )
            }
        }
    }
}

@Composable
internal fun AcademicYearsPageHeader(
    modifier: Modifier = Modifier
) {
    Column(modifier = modifier, verticalArrangement = Arrangement.spacedBy(10.dp)) {
        Text(
            text = "Academic Years",
            color = AppPageHeader,
            fontSize = 30.sp,
            fontWeight = FontWeight.Bold
        )
        Text(
            text = "Define academic term windows and lifecycle",
            color = AppPageSubtitle,
            fontSize = 15.sp,
            fontWeight = FontWeight.Medium
        )
    }
}
